import React from 'react';
import { Building2 } from 'lucide-react';

export const defaultOtherQuestions = [
  {
    id: 'logo',
    placeholder: 'logo',
    title: 'uploadLogo',
    type: 'avatar',
    image: <Building2 size={60} className='file-icon' />,
    mandatory: false,
  },
  {
    id: 'name',
    type: 'text',
    title: 'name',
    placeholder: 'name',
    mandatory: true,
  },
  {
    id: 'description',
    type: 'text',
    title: 'description',
    placeholder: 'description',
    mandatory: true,
  },
  {
    id: 'subType',
    type: 'select',
    title: 'type',
    placeholder: 'type',
    answers: ['Art', 'Collectibles', 'Precious Metals', 'Other'],
    mandatory: false,
  },
  {
    id: 'identifier',
    type: 'text',
    title: 'identifier',
    placeholder: 'identifier',
    mandatory: false,
  },
];
